import React from 'react';

// Logo unique - Main avec Clé en lévitation (verrouillé)
const Logo6 = () => (
  <div className="flex items-center gap-2.5">
    <img 
      src="/icons/logo-main-cle-5.png" 
      alt="Hypnose clé" 
      className="w-11 h-11 rounded-lg object-cover shadow-md shadow-amber-500/20 border border-amber-500/30" 
    />
    <span className="text-white font-heading text-lg font-semibold tracking-wide hidden sm:block">Hypnose clé</span>
  </div>
);

// Export unique - pas de sélecteur, logo verrouillé
export { Logo6 };
export const Logo1 = Logo6;
export const Logo2 = Logo6;
export const Logo3 = Logo6;
export const Logo4 = Logo6;
export const Logo5 = Logo6;
export const Logo7 = Logo6;
export const Logo8 = Logo6;

export default Logo6;
